module.exports = __webpack_public_path__ + "img/android.399bac58.svg";